import { INBOX_TYPES } from 'dashboard/helper/inbox';

const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk Pro' },
    created_at: 1736033561,
    translationKey: 'SUPPORT_GENIE',
    id: 4,
  },
  {
    account_id: 3,
    config: { product_name: 'CRM Tools' },
    created_at: 1736033562,
    translationKey: 'CRM_ASSISTANT',
    id: 5,
  },
  {
    account_id: 4,
    config: { product_name: 'SalesFlow' },
    created_at: 1736033563,
    translationKey: 'SALES_BOT',
    id: 6,
  },
  {
    account_id: 5,
    config: { product_name: 'TicketMaster AI' },
    created_at: 1736033564,
    translationKey: 'TICKET_BOT',
    id: 7,
  },
  {
    account_id: 6,
    config: { product_name: 'FinanceAssist' },
    created_at: 1736033565,
    translationKey: 'FINANCE_WIZARD',
    id: 8,
  },
  {
    account_id: 8,
    config: { product_name: 'HR Assistant' },
    created_at: 1736033567,
    translationKey: 'HR_HELPER',
    id: 10,
  },
];

const documentsList = [
  {
    account_id: 1,
    translationKey: 'CONVERSATION_FILTERS',
    assistant: { id: 1 },
    content:
      'Comprehensive guide on using conversation filters to manage chats effectively.',
    created_at: 1736143272,
    id: 3059,
    status: 'available',
  },
  {
    account_id: 2,
    translationKey: 'TICKET_ASSIGNMENTS',
    assistant: { id: 2 },
    content:
      'Step-by-step guide for automating ticket assignments and improving support workflows.',
    created_at: 1736143273,
    id: 3060,
    status: 'available',
  },
  {
    account_id: 3,
    translationKey: 'CUSTOMER_PROFILES',
    assistant: { id: 3 },
    content:
      'A detailed guide on managing and organizing customer profiles for better relationship management.',
    created_at: 1736143274,
    id: 3061,
    status: 'available',
  },
  {
    account_id: 4,
    translationKey: 'SALES_TRACKING',
    assistant: { id: 4 },
    content:
      'Learn how to optimize sales tracking and improve your sales forecasting using advanced features.',
    created_at: 1736143275,
    id: 3062,
    status: 'available',
  },
  {
    account_id: 5,
    translationKey: 'TICKET_MANAGEMENT',
    assistant: { id: 5 },
    content: 'How to efficiently create, manage, and resolve support tickets.',
    created_at: 1736143276,
    id: 3063,
    status: 'available',
  },
  {
    account_id: 6,
    translationKey: 'FINANCIAL_REPORTING',
    assistant: { id: 6 },
    content:
      'Detailed guide on how to use financial reporting tools and generate insightful analytics.',
    created_at: 1736143277,
    id: 3064,
    status: 'available',
  },
];

const responsesList = [
  {
    account_id: 1,
    translationKey: 'MESSENGER_DEACTIVATED',
    created_at: 1736283330,
    id: 87,
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Customer Support' },
      created_at: 1736033280,
      description: 'Assists with general queries and system-wide issues.',
      id: 1,
    },
  },
  {
    account_id: 2,
    translationKey: 'WHATSAPP_INTEGRATION',
    created_at: 1736283340,
    id: 88,
    assistant: {
      account_id: 2,
      config: { product_name: 'Customer Support' },
      created_at: 1736033281,
      description: 'Helps with integration and setup-related inquiries.',
      id: 2,
    },
  },
  {
    account_id: 3,
    translationKey: 'RESET_PASSWORD',
    created_at: 1736283350,
    id: 89,
    assistant: {
      account_id: 3,
      config: { product_name: 'Customer Support' },
      created_at: 1736033282,
      description: 'Handles account management and recovery support.',
      id: 3,
    },
  },
  {
    account_id: 4,
    translationKey: 'DARK_MODE',
    created_at: 1736283360,
    id: 90,
    assistant: {
      account_id: 4,
      config: { product_name: 'Customer Support' },
      created_at: 1736033283,
      description: 'Helps with UI and theme-related inquiries.',
      id: 4,
    },
  },
  {
    account_id: 5,
    translationKey: 'TEAM_MEMBER',
    created_at: 1736283370,
    id: 91,
    assistant: {
      account_id: 5,
      config: { product_name: 'Customer Support' },
      created_at: 1736033284,
      description: 'Supports team management and user access-related queries.',
      id: 5,
    },
  },
  {
    account_id: 6,
    translationKey: 'CAMPAIGNS',
    created_at: 1736283380,
    id: 92,
    assistant: {
      account_id: 6,
      config: { product_name: 'Customer Support' },
      created_at: 1736033285,
      description:
        'Specialized in marketing, campaign management, and messaging strategies.',
      id: 6,
    },
  },
];

const inboxes = [
  {
    id: 7,
    translationKey: 'EMAIL_SUPPORT',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    translationKey: 'WEBSITE_CHAT',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    translationKey: 'FACEBOOK_SUPPORT',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    translationKey: 'SMS_SERVICE',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    translationKey: 'WHATSAPP_SUPPORT',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    translationKey: 'TELEGRAM_SUPPORT',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    translationKey: 'LINE_SUPPORT',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    translationKey: 'API_CHANNEL',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    translationKey: 'SMS_BASIC',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];

export const localizeAssistantsList = translations =>
  assistantsList.map(assistant => ({
    ...assistant,
    name: translations.ASSISTANTS[assistant.translationKey].NAME,
    description: translations.ASSISTANTS[assistant.translationKey].DESCRIPTION,
  }));

export const localizeDocumentsList = translations =>
  documentsList.map(document => {
    const copy = translations.DOCUMENTS[document.translationKey];

    return {
      ...document,
      name: copy.NAME,
      external_link: copy.LINK,
      assistant: {
        ...document.assistant,
        name: copy.ASSISTANT,
      },
    };
  });

export const localizeResponsesList = translations =>
  responsesList.map(response => {
    const copy = translations.RESPONSES[response.translationKey];

    return {
      ...response,
      question: copy.QUESTION,
      answer: copy.ANSWER,
      assistant: {
        ...response.assistant,
        name: copy.ASSISTANT,
      },
    };
  });

export const localizeInboxes = translations =>
  inboxes.map(inbox => ({
    ...inbox,
    name: translations.INBOXES[inbox.translationKey],
  }));
